import { database } from "services/firebaseService/firebaseConfig";
import { getEventPrefix } from "modules/event/firebase";
import { ref } from "firebase/database";

export const getEventStatusDocRef = (eventId: string) =>
  ref(database, `${getEventPrefix()}/${eventId}/Details/status/`);
